var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V14.6667",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66664 25.3333H25.3333C26.2167 25.3271 27.0397 24.8838 27.5309 24.1496C28.0222 23.4154 28.1179 22.4856 27.7866 21.6666L18.32 5.33331C17.8503 4.48447 16.9567 3.95764 15.9866 3.95764C15.0165 3.95764 14.123 4.48447 13.6533 5.33331L4.18664 21.6666C3.86184 22.4663 3.94414 23.3737 4.40751 24.1019C4.87089 24.83 5.65803 25.2889 6.51998 25.3333",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3333H16.0134",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.82ff89c6e58684484b040d54dc4e8ccf.svg";
export { ForwardRef as ReactComponent };